import { Badge } from '@speaking-coach/ui'
import { TUTOR_POPULARITY_THRESHOLD, type TutorPopularity } from './catalog-types.js'

const percentage = (value: number) => `${(value * 100).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`

export function TutorPopularityValue({ popularity, inline = false }: { popularity?: TutorPopularity | null; inline?: boolean }) {
  if (!popularity) return <span className="text-text-secondary">Unavailable</span>
  const calls = `${popularity.callCount.toLocaleString('en-US')} ${popularity.callCount === 1 ? 'call' : 'calls'}`
  if (inline) return <><span>{percentage(popularity.relativeToTop)} of top</span><span aria-hidden="true">·</span><span>{calls} · {percentage(popularity.share)} share</span></>
  return <><p>{percentage(popularity.relativeToTop)} of top</p><p className="text-table-secondary text-text-secondary">{calls} · {percentage(popularity.share)} share</p></>
}

export function TutorPopularityBadge({ popularity }: { popularity?: TutorPopularity | null }) {
  if (!popularity || popularity.callCount <= 0 || popularity.relativeToTop < TUTOR_POPULARITY_THRESHOLD) return null
  return <Badge variant="accent" title={`At least ${TUTOR_POPULARITY_THRESHOLD * 100}% of the top coach’s regular calls in the last 30 days.`}>Popular</Badge>
}
